import { render } from "./view-sales-order.vue?vue&type=template&id=7835a80e"
import script from "./view-sales-order.vue?vue&type=script&lang=js"
export * from "./view-sales-order.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__